export default __webpack_public_path__ + "static/media/summary_planimages_84b.6a48fb9b.png";